const messagesInFrench = {
    financialServices: "Services financiers",
};

export { messagesInFrench };
